<template>
  <div>
    <!-- 头部状态条 -->
    <HeaderInfo></HeaderInfo>
    <!-- 内容部分 -->
    <div class="content">
      <div class="content_search">
        <el-form
          ref="purchaseQueryRef"
          :model="purchaseQuery"
          label-width="100px"
        >
          <el-form-item label="采购单名称:">
            <el-input v-model="purchaseQuery.purchase_name"></el-input>
          </el-form-item>
          <el-form-item label="筛选:">
            <el-cascader
              placeholder="请选择类型"
              v-model="suppleSelect"
              :options="suppleOptions"
              :props="suppleProps"
              @change="changeSelect"
              filterable
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <div class="search" @click="search">查 询</div>
              <el-button @click="reset">重 置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表单内容 -->
      <div class="content_box">
        <div
          class="list_content"
          v-for="(item, index) in purchaseList"
          :key="index"
          @click="goPurchase(item.id)"
        >
          <div class="purchase_list_info">
            <div class="list_img">
              <img :src="item.cover" alt="" />
              <div class="img_category">
                {{ item.category.purchase_name }}
              </div>
            </div>
            <div class="purchase_list_right">
              <div class="purchase_name_info">
                <div class="purchase_name overflow1">
                  {{ item.purchase_name }}
                </div>
                <div
                  class="purchase_statu"
                  :class="item.purchase_status === 1 ? '' : 'secondary_color'"
                >
                  {{ item.purchase_status == 1 ? "报价中" : "报价结束" }}
                </div>
              </div>
              <div class="purchase_label">
                <div class="purchase_label_left">
                  <p>{{ item.invoice.name }}</p>
                  <p>{{ item.quote_price.name }}</p>
                  <p v-if="item.tax">{{ item.tax.name }}</p>
                </div>
                <div class="purchase_time">截止时间：{{ item.deadline }}</div>
              </div>
              <!-- 发布单位、用材地址 -->
              <div class="purchase_address overflow1">
                <span style="margin-right: 20px"
                  >发布单位：{{ item.company_name }}</span
                >
                <span>用材地址：{{ item.address }}</span>
              </div>
              <!-- 采购数量 -->
              <div class="purchase_label">
                <div class="purchase_count">
                  采购 {{ item.purchase_count }} 件
                </div>
                <div class="purchase_btn_info">查看详情</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="purchaseQuery.page"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="purchaseQuery.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="detailedListTotal"
            :hide-on-single-page="hideSinglePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <FooterInfo></FooterInfo>
  </div>
</template>
<script>

import { Loading } from "element-ui";
export default {
  components: {

  },
  data() {
    return {
      purchaseList: [],
      purchaseQuery: {
        page: 1,
        size: 10,
        purchase_name: "",
        purchase_category_id: "",
      },
      suppleSelect: [],
      suppleOptions: [],
      suppleProps: {
        expandTrigger: "hover",
        value: "purchase_id",
        label: "purchase_name",
        children: "children",
      },
      detailedListTotal: 0,
      hideSinglePage: true,
    };
  },
  created() {
    this.getSuppleType();
    this.getPurchaseList();
  },
  methods: {
    async getSuppleType() {
      let { data: res } = await this.$http.post("v1/user/ident/type");
      // let { data: res } = await this.$http.get("v1/common/supplier/type");
      this.suppleOptions = res;
    },
    changeSelect() {
      // console.log(this.suppleSelect[1]);
      this.purchaseQuery.purchase_category_id = this.suppleSelect[1];
    },
    search() {
      this.getPurchaseList();
    },
    reset() {
      this.purchaseQuery.purchase_category_id = "";
      this.purchaseQuery.purchase_name = "";
      this.suppleSelect=[]
      this.getPurchaseList();
    },
    // 获取采购单列表
    async getPurchaseList() {
      let loadingInstance = Loading.service();
      const { data: res } = await this.$http.get("v1/purchase/list", {
        params: this.purchaseQuery,
      });
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      });
      this.purchaseList = res.data.list;
      this.detailedListTotal = res.data.count;
    },
    // 跳转采购单详情
    goPurchase(id) {
      // console.log("跳转采购单详情" + id);
      this.$router.push({
        path: "/purchaseDetail",
        query: {
          id: id,
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.purchaseQuery.size = val;
      this.getPurchaseList();
    },
    handleCurrentChange(val) {
      this.purchaseQuery.page = val;
      this.getPurchaseList();
    },
  },
};
</script>
<style scoped>
.content {
  width: 1200px;
  margin: 20px auto;
  background: #fff;
  border-radius: 4px;
  padding-top: 20px;
}
.content_search {
  border-bottom: 1px solid #eee;
}
.content_box {
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  width: 450px;
}
.el-cascader {
  width: 100%;
}

.search {
  background: #20ab3a;
  color: #fff;
  cursor: pointer;
  width: 80px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  margin-right: 20px;
}
.btn {
  display: flex;
}

.list_content {
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}
.purchase_list_info {
  display: flex;
}
.list_content {
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}
.list_img {
  width: 130px;
  height: 130px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.img_category {
  position: absolute;
  top: 0;
  left: 0;
  background: #20ab3a;
  color: #fff;
  font-size: 13px;
  padding: 2px 5px 2px 5px;
}
.purchase_list_right {
  margin-left: 20px;
  width: 1010px;
}
.purchase_name_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.purchase_name {
  font-size: 22px;
  color: #333;
}
.purchase_statu {
  color: #20ab3a;
  font-size: 20px;
  font-weight: 500;
  text-align: right;
}
.secondary_color {
  color: #dc5b56;
}
.purchase_label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.purchase_label_left {
  font-size: 13px;
  display: flex;
}
.purchase_label_left > p {
  margin-right: 10px;
  padding: 2px 8px 2px 8px;
  background: #20ab3a;
  color: #fff;
}
.purchase_time {
  color: #333;
  font-size: 16px;
}
.purchase_address {
  font-size: 14px;
  color: #999;
  margin-top: 10px;
}
.purchase_count {
  color: #dc5b56;
  font-size: 20px;
}
.purchase_btn_info {
  background: #20ab3a;
  border-radius: 5px;
  padding: 5px 12px;
  color: #fff;
  font-size: 15px;
}

.pagination {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
}
</style>